import { render } from "./QualificationDeleteModal.vue?vue&type=template&id=747a277e"
import script from "./QualificationDeleteModal.vue?vue&type=script&lang=js"
export * from "./QualificationDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__